import React from "react";
import "./banner.css";

import banner1 from "../../../assets/newImg/h11.png";
import banner2 from "../../../assets/newImg/h15.png";

import UseMediaQuery from "./../UseMediaQuery";

const Banner = () => {
  const isMobile = UseMediaQuery("(max-width:486px)");
  return (
    <div className="container">
      {" "}
      <div className="row">
        <div className="col-12 ">
          <div className="card cardBg position-relative">
            {/* Background Image */}

            {isMobile ? (
              <>
                {" "}
                <img
                  src={banner2}
                  className="card-img secOneImg1"
                  alt="banner"
                />
              </>
            ) : (
              <>
                {" "}
                <img
                  src={banner1}
                  className="card-img secOneImg10 "
                  alt="banner"
                />
              </>
            )}

            {/* Text Overlay */}
            <div className="card-img-overlay banOverlay">
              <div className=""></div>
              {/* <h5 className="card-title text-center bannerh1 mt-xxl-3 mt-xl-3 mt-lg-3 mt-md-3 mt-sm-3 mt-3">
                You build once, we bring trusted
                <span className="banPurpleText">&nbsp;experts together.</span>
                <br />
              </h5> */}
              <h5 className="card-title text-center bannerh1 mt-xxl-3 mt-xl-3 mt-lg-3 mt-md-3 mt-sm-3 mt-3">
                A home is built only once in a lifetime,
                <span className="banPurpleText">&nbsp;Mestry circle</span>{" "}
                <span className="bannerh1">
                  {" "}
                  connects you with trusted partner to turn your dream in to
                  reality.
                </span>
                <br />
              </h5>

              {/* <p className="card-text text-center  banPara mt-4">
                <span className="bannerP1">
                  {" "}
                  No more confusion. Get verified &nbsp;
                </span>{" "}
                <strong className="bannerStrong">contractors</strong>,{" "}
                <span className="bannerP1"> Build with</span>
                <br /> <span className="bannerP1">trust, save time, </span>
                <strong className="bannerStrong">feel confident,</strong>
                <span className="bannerP1"> and</span>
                <strong className="bannerStrong"> &nbsp;every step</strong>
                <span className="bannerP1"> of the way.</span> &nbsp;
              </p> */}
              {/* <p className="card-text text-center  banPara mt-4">
                <span className="bannerP1">
                  {" "}
                  No more confusion, get verified{" "}
                  <strong className="bannerStrong">
                    <span className="bannerP1">
                      {" "}
                      contractors build with confident.
                    </span>
                  </strong>
                </span>{" "}
              </p> */}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="row">
        {" "}
        <div className="col-12 hrFooter"></div>
      </div> */}
    </div>
  );
};

export default Banner;

// import React from "react";
// import "./banner.css";

// import banner1 from "../../../assets/newImg/h7.png";
// import banner2 from "../../../assets/newImg/h6.png";
// import UseMediaQuery from "./../UseMediaQuery";

// const Banner = () => {
//   const isMobile = UseMediaQuery("(max-width:486px)");
//   return (
//     <div
//       className="container secOneImg1"
//       style={{
//         backgroundImage: ` url(${isMobile ? banner2 : banner1})`,
//         backgroundRepeat: "no-repeat",
//         backgroundSize: "100% 100%",
//         backgroundPosition: "center",
//       }}
//     >
//       {" "}
//       <div className="row">
//         <div className="col-12 ">
//           <h5 className="card-title text-center bannerh1 mt-xxl-3 mt-xl-3 mt-lg-3 mt-md-3 mt-sm-3 mt-3">
//             A home is built only once in a lifetime,
//             <span className="banPurpleText">&nbsp;Mestry circle</span>{" "}
//             <span className="bannerh1">
//               {" "}
//               connects you with trusted partner to turn your dream in to
//               reality.
//             </span>
//             <br />
//           </h5>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Banner;
